import { Box } from "@mui/material"
import { memo } from "react"
import './NewLabel.css'

const NewLabel = ({ label = 'Novo !', fontSize = '12px', color = '#7500A2' }) => {
    return (
        <Box className="blink" sx={{ color: color + ' !important', fontSize: fontSize + ' !important' }}>{label}</Box>
    )
}

export default memo(NewLabel)
